import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const submitFeedbackApi = (feedbackData) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.LEGAL_CHAT_FEEDBACK}`, feedbackData);

export const storeComplaintApi = (payload) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.STORE_COMPLAINT}`, payload);
